import * as React from 'react';
export const CMSvg = React.forwardRef(function CMSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#159570',
        d: 'M2.005 2A2.008 2.008 0 0 0 0 4.009v7.982C0 13.101.894 14 2.005 14H5V2H2.005Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M11 2v12h2.995A2.008 2.008 0 0 0 16 11.991V4.01C16 2.899 15.106 2 13.995 2H11Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M11 3V2h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3v-1h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-3Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M5 2h6v12H5z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        fillRule: 'nonzero',
        d: 'm10.296 7.167-1.458.003a.202.202 0 0 1-.193-.14l-.452-1.388a.202.202 0 0 0-.386 0l-.45 1.387a.202.202 0 0 1-.193.14h-1.46a.202.202 0 0 0-.118.368l1.18.857a.202.202 0 0 1 .073.227l-.45 1.388a.202.202 0 0 0 .312.227l1.18-.792a.202.202 0 0 1 .239 0l1.18.792a.202.202 0 0 0 .313-.227L9.161 8.62a.202.202 0 0 1 .074-.227l1.18-.857a.205.205 0 0 0-.12-.37Z',
      }),
    ),
  );
});
CMSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CM = {
  category: 'flag',
  colorable: false,
  name: 'CM',
  svg: CMSvg,
};
